import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectCurrentUserData = createSelector(
    state => state.currentUserData,
    currentUserData => currentUserData
)

export const useCurrentUserData = () => useSelector(selectCurrentUserData);